<section [ngClass]="isMobileView ? 'm-room-card' : 'room-card'" class="card">
  <div class="card-image-badge">
    <div (click)="openRoomDetails()" class="card-image background-loading cursor-pointer">
      <img [src]="room?.imageUrl" alt="" appDefaultImage="assets/images/defaults/room.png" />
    </div>

    <app-badge [text]="room?.noOfPersons + ' ' + ('courses.persons' | translate)" [type]="'gradient'" borderRadius="6px" positionLeft="12px" positionTop="10px"></app-badge>
  </div>
  <div class="card-content">
    <h2 (click)="openRoomDetails()" class="card-title cursor-pointer">{{ room?.name }}</h2>

    <div class="card-location">
      <app-icon [size]="isMobileView ? '20px' : '16px'" iconName="marker"></app-icon>
      <p class="location">{{ room?.address }}</p>
    </div>

    <div class="room-schedule-wrapper">
      @for (availability of room.availability; let i = $index; track availability.id) {
        <div class="room-schedule">
          @if (i === 0 || availability.weekday !== room.availability[i - 1].weekday) {
            <p class="room-day">
              {{ availability.weekday | weekday }}
            </p>
          }
          <div class="room-timings">
            <p class="room-timing">{{ availability.timeFrom }} - {{ availability.timeTo }} {{ 'Clock' | translate }}</p>
          </div>
        </div>
      }
    </div>

    @if (isUserAdmin) {
      @if (!isMobileView) {
        <div class="actions buttons-container buttons-full">
          <button (click)="editRoom.emit(room)" [tippy]="'Edit' | translate" class="button button-simple button-icon-only">
            <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="pencil-square" size="20px"></app-icon>
          </button>
          <button (click)="deleteRoom.emit(room)" [tippy]="'Delete' | translate" class="button button-simple button-icon-only">
            <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash" size="20px"></app-icon>
          </button>
        </div>
      } @else {
        <div class="actions flex-row-center-center buttons-full">
          <button (click)="editRoom.emit(room)" class="button button-simple button-icon-only">
            <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="pencil-square" size="20px"></app-icon>
          </button>
          <button (click)="deleteRoom.emit(room)" class="button button-simple button-icon-only">
            <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash" size="20px"></app-icon>
          </button>
        </div>
      }
    }
  </div>
</section>
